import './styles.scss';

type ToggleSwitchProps = {
  isOn: boolean;
  setIsOn: (value: boolean) => void;
  isDisabled?: boolean;
};

export const ToggleSwitch = ({ isOn, setIsOn, isDisabled = false }: ToggleSwitchProps) => {
  const handleToggle = () => {
    setIsOn(!isOn);
  };

  return (
    <div
      className={`toggle-switch ${isOn ? 'on' : 'off'} ${isDisabled ? 'toggle-disabled' : ''}`}
      onClick={handleToggle}
    >
      <div className="toggle-thumb"></div>
    </div>
  );
};
